import { memo } from "react";
import Tooltip from "@mui/material/Tooltip";
import { TooltipProps } from "./sy-tooltip-interface";

const SyTooltip = (props: TooltipProps) => {
  const { title = "", children, followCursor = false } = props;
  return (
    <Tooltip title={title} followCursor={followCursor} arrow>
      {children}
    </Tooltip>
  );
};

export default memo(SyTooltip);
